<template>
	<div class="createorder" ref="createorder">
		<el-form ref="createorderform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<export1 ref="export1" @formScrollTop="formScrollTop" @cancel="cancel"></export1>
			<import1 ref="import1" @formScrollTop="formScrollTop" @cancel="cancel"></import1>
			<inner1 ref="inner1" @formScrollTop="formScrollTop" @cancel="cancel"></inner1>
		</el-form>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import export1 from '@/components/order/createorder_export_1.vue';
import import1 from '@/components/order/createorder_import_1.vue'; //下单选择商品库的，且选择的商品不可以更改信息，只可以更改数量
import inner1 from '@/components/order/createorder_inner_1.vue'; //境内包裹
export default {
	components: {
		export1,
		import1,
		inner1
	},
	props: {},
	data() {
		return {
			windowHeight: window.innerHeight - 120,
			pmodelist: [],
			divclass: 'createorder',
			syscol: '',
			t_id: '',
			p_mode_remark: '',
			checkedpmode: '',
			orderinfo: {},
			p_pkval: '',
			iscopy: 0, //0-新增 1-复制新增
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/createorder.scss');
		});
	},
	methods: {
		init(param) {
			debugger
			if (param.pkval != undefined) this.p_pkval = param.pkval;
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			this.orderinfo={};
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			//this.pkval='SYS000000031';
			//this.iscopy='1';
			if (this.p_pkval != '') {
				this.GetOrderInfo();
			}
			else {
				this.GetPageLayout();;
			}
		},
		// //获取渠道
		// GetClarance() {
		// 	var that = this;
		// 	this.$tool.loading('正在加载', this.divclass);
		// 	//先加载渠道
		// 	this.$apipost.get.GetClarance().then(res => {
		// 		that.pmodelist = res.list;
		// 		if (that.pmodelist.length > 0) {
		// 			if (that.orderinfo.p_mode!=undefined) {
		// 				that.checkedpmode = that.orderinfo.p_mode;
		// 				that.pmodelist.forEach(e => {
		// 					if (e.d_name == that.checkedpmode) {
		// 						that.p_mode_remark = e.remark;
		// 						return false;
		// 					}
		// 				});
		// 			} else {
		// 				that.checkedpmode = that.pmodelist[0].d_name;
		// 				that.orderinfo.p_mode = that.checkedpmode;
		// 				that.p_mode_remark = that.pmodelist[0].remark;
		// 			}
		// 			that.GetPageLayout();
		// 		} else {
		// 			this.$tool.loadingclose();
		// 		}
		// 	});
		// },
		//获取订单信息
		GetOrderInfo() {
			//获取订单信息
			this.$tool.loading('正在加载', this.divclass);
			var that=this;
			this.$apipost.get.GetOrderInfo_More({pkval:this.p_pkval}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					that.orderinfo=res.orderinfo;
					that.GetPageLayout();
					if(that.iscopy=='1'){
						that.p_pkval='';
					}
				}else{
					this.$tool.message(res.message,"0");
				}
			});
		},
		GetPageLayout() {
			var that = this;
			this.truncatepage();
			this.$tool.loading('正在加载', this.divclass);
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.GetTransFormat({ p_mode:'' }).then(res => {
					this.$tool.loadingclose();
					//console.log('组件',res);
					if (res.state == '1') {
						if(res.list!=undefined){
							if(res.list.length>0){
								res.list.forEach(e=>{
									if(e.t_type=='境内包裹'){
										that.t_id = e.t_id;
										that.$refs.inner1.init({
											syscol: e.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											checkedpmode:'',
											t_id: e.t_id
										});
										return false;
									}
								});
							}
							else{
								if(res.set!=undefined){
									if(res.set.t_type=='境内包裹'){
										that.t_id = res.set.t_id;
										that.$refs.inner1.init({
											syscol: res.set.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											checkedpmode:'',
											t_id: res.set.t_id
										});
									}
								}
							}
						}
					}
				});
		},
		//滚动条滚动到顶部
		formScrollTop() {
			this.$nextTick(() => {
				this.$refs.createorderform.$el.scrollTop = this.$refs.createorderform.$el.scrollHeight;
			});
		},
		//初始化页面
		truncatepage() {
			if (this.$refs.export1 != undefined) this.$refs.export1.isload = false;
			if (this.$refs.import1 != undefined) this.$refs.import1.isload = false;
		},
		cancel() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
};
</script>

<style></style>
